/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import { useState } from 'react';
import PropTypes from 'prop-types';

import { useMediaQuery } from '@mantine/hooks';
import { breakpoints } from 'styles/theme.variables';

import { Select } from '@mantine/core';

export default function EditableDropdown({ handleEdit, displayValue, value, disableEdit }) {
  const [isEditing, setIsEditing] = useState(false);
  const [currentValue, setCurrentValue] = useState('');

  const isDesktop = useMediaQuery(`(min-width: ${breakpoints.lg})`);

  const handleBlur = () => {
    if (currentValue !== value) {
      handleEdit('isDefault', currentValue === 'true');
    }
    setIsEditing(false);
  };

  const startEditing = () => {
    if (disableEdit) return;

    if (isDesktop) {
      setCurrentValue(value);
      setIsEditing(true);
    }
  };

  if (isEditing) {
    return (
      <Select
        data={[
          { value: 'true', label: 'Default' },
          { value: 'false', label: 'Not default' },
        ]}
        value={currentValue}
        onChange={setCurrentValue}
        onBlur={handleBlur}
        autoFocus
        maw={168}
        comboboxProps={{ width: 200, position: 'bottom-start' }}
      />
    );
  }

  return (
    <div
      onClick={startEditing}
      style={{
        cursor: disableEdit ? 'not-allowed' : 'pointer',
      }}
    >
      {displayValue}
    </div>
  );
}

EditableDropdown.propTypes = {
  handleEdit: PropTypes.func,
  displayValue: PropTypes.string,
  value: PropTypes.string,
  disableEdit: PropTypes.bool,
};

EditableDropdown.defaultProps = {
  disableEdit: false,
};
